export default __webpack_public_path__ + "static/media/BenefitsInfoIcon.8b2e93a8.svg";